export default __webpack_public_path__ + "static/media/sales.1ae0b45b.svg";